import React from 'react';

import './FooterOverlay.css';

const FooterOverlay = () => (
  <div>
    
  </div>
);

export default FooterOverlay;
